// extracted by mini-css-extract-plugin
module.exports = {"logo":"g-project-logo_logo_CQxNq","title":"g-project-logo_title_2IDWn","dark":"g-project-logo_dark_1lnKW","subtitle":"g-project-logo_subtitle_23vvW"};